const mailchimpForm = document.querySelector('.js-mailchimp-form');

if (mailchimpForm) {


    mailchimpForm.addEventListener("submit", (e) => {
        e.preventDefault();

        if (mailchimpForm.querySelector("input[type=email]").value) {

            fetch(e.target.action, {
                method: 'post',
                body: new URLSearchParams(new FormData(mailchimpForm))
            }).then(res => res.text())
                .then(window.location = e.target.dataset.redirectTo)
                .catch(err => {
                    console.log(err);
                })
        } else {
            mailchimpForm.querySelector("input[type=email]").parentElement.style.borderColor = '#D84B1F';
        }
    })

}